import { DEV } from "solid-js"
import isAppleSiliconByWebGL from "../hardware/isAppleSiliconByWebGL"

const IS_ELECTRON = false
const IS_TAURI = false
const IS_CAPACITOR = false
const IS_CORDOVA = false

export default function getDefaultWorkerCount() {
  const maxWorkersDesktop = 4
  const maxWorkersMobile = 4
  const minWorkers = 1
  const hc = navigator.hardwareConcurrency || 2

  if (IS_ELECTRON) {
    // Electron runs in a desktop environment with plenty of resources.
    // Use full hardware concurrency but cap it.
    return Math.max(minWorkers, Math.min(maxWorkersDesktop, hc))
  }
  if (IS_TAURI) {
    // Same as Electron: native wrapper, desktop-like environment.
    return Math.max(minWorkers, Math.min(maxWorkersDesktop, hc))
  }
  if (IS_CAPACITOR) {
    // Capacitor runs on mobile (iOS/Android), hardware is limited.
    // Be conservative: half the cores, but at least 1, cap at 4.
    return Math.max(minWorkers, Math.min(maxWorkersMobile, Math.floor(hc / 2)))
  }
  if (IS_CORDOVA) {
    // Similar to Capacitor: mobile, embedded.
    return Math.max(minWorkers, Math.min(maxWorkersMobile, Math.floor(hc / 2)))
  }
  if (DEV) {
    return 1
  }
  // console.log('isAppleSiliconByWebGL()', isAppleSiliconByWebGL())
  if (isAppleSiliconByWebGL()) {
    // Apple Silicon might have P/E cores but does not do hyperthreading.
    return Math.max(minWorkers, Math.min(maxWorkersDesktop, hc))
  }
  // --- Default: Browser ---
  // In browsers, hyperthreading inflates the reported number.
  // Divide by 2, clamp between 1–8.
  return Math.max(minWorkers, Math.min(maxWorkersDesktop, Math.floor(hc / 2)))
}
